import { useMemo, useState, useEffect } from 'react';
import { getViewReportApi } from '@intelligence/services/reportService';
import { formatReportLike } from '@intelligence/pages/InsightsReport/_config';
import type { IPDFPreviewDownloadURLSearchParams } from '../../PDFPreviewDownload/types';

interface IUseViewProps extends IPDFPreviewDownloadURLSearchParams {
  execute: boolean;
}

export default function useView(props: IUseViewProps) {
  const { id, execute, systemId, resourceId, studioAble } = props;
  const [viewCnt, setViewCn] = useState(0);

  const viewCntFormatted = useMemo<string>(() => formatReportLike(viewCnt), [viewCnt]);

  const handleView = async () => {
    try {
      const viewData = await getViewReportApi({
        system: systemId,
        resource_id: resourceId || '',
        id: id,
      });
      setViewCn(viewData);
    } catch (e) {
      console.log(e);
    }
  };


  useEffect(() => {
    if (execute && id && studioAble) {
      handleView();
    }
  }, [execute, studioAble, id, resourceId, systemId]);

  return {
    viewCnt: viewCntFormatted,
  };
}
